enum TriggerType {
  CLICK = 'click',
  HOVER = 'hover',
}

export { TriggerType }
